import styled from 'styled-components';

export const SelectCycleStepWrapperStyled = styled.div`
  min-height: 320px;
`;

export const SelectCycleStyled = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SelectCycleMessageBoxStyled = styled.div`
  margin: 20px 0;
  max-width: 900px;
`;
